import React from 'react'
import ErpLayout from '../../../../../layout/components/ErpLayout'


function VendorListPage() {
  return (
    <ErpLayout>
      <div className='row'>
        <div className='col-md-12'>
          <div>VendorListpage</div>    
        </div>
      </div>
    </ErpLayout>
  )
}

export default VendorListPage